import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  infoBox: {
    width: '100%',
    maxWidth: 430,
    marginTop: 20,
  },
  infoBoxEmail: {
    color: palette.primary.main,
    lineHeight: 1.5,
  },
}));
